var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDartYes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 57C24.562 57 15 47.437 15 35.75c0-11.688 9.563-21.25 21.25-21.25 11.688 0 21.25 9.563 21.25 21.25C57.5 47.438 47.937 57 36.25 57zm0-40.375A19.045 19.045 0 0017.125 35.75c0 10.625 8.5 19.125 19.125 19.125s19.125-8.5 19.125-19.125-8.5-19.125-19.125-19.125z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 49.563A13.785 13.785 0 0122.437 35.75c0-7.65 6.163-13.813 13.813-13.813S50.063 28.1 50.063 35.75 43.9 49.563 36.25 49.563zm0-25.5c-6.375 0-11.688 5.312-11.688 11.687 0 6.375 5.313 11.688 11.688 11.688 6.375 0 11.688-5.313 11.688-11.688 0-6.375-5.313-11.688-11.688-11.688z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 42.125c-3.612 0-6.375-2.763-6.375-6.375s2.763-6.375 6.375-6.375 6.375 2.763 6.375 6.375-2.763 6.375-6.375 6.375zm0-10.625A4.262 4.262 0 0032 35.75 4.262 4.262 0 0036.25 40a4.262 4.262 0 004.25-4.25 4.262 4.262 0 00-4.25-4.25z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 36.813c-.212 0-.637 0-.85-.213a1.027 1.027 0 010-1.487l15.938-15.938a1.027 1.027 0 011.488 0 1.027 1.027 0 010 1.488L36.888 36.6c0 .213-.425.213-.637.213z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 20.875h-5.313c-.637 0-1.062-.425-1.062-1.063V14.5c0-.213.212-.637.212-.85l7.438-7.438C59.2 6 59.625 6 60.05 6c.425.213.638.638.638 1.063v4.25h4.25c.424 0 .85.212 1.062.637 0 .425 0 .85-.213 1.275l-7.437 7.438c-.212 0-.638.212-.85.212zm-4.25-2.125h3.825l5.313-5.313h-2.763c-.638 0-1.063-.425-1.063-1.062V9.613l-5.312 5.312v3.825z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })));
}

export default SvgDartYes;